import type React from "react";

import { Button } from "components/Theme/button";
import Papa, { type ParseResult } from "papaparse";
import { useDropzone } from "react-dropzone";

type CSVRow = Record<string, unknown>;

interface Props {
  parseComplete: (data: Promise<ParseResult<CSVRow>>, filename: string) => void;
  buttonLabel?: string;
}

const processAcceptFiles = (
  acceptedFiles: File[],
  parseComplete: (data: Promise<ParseResult<CSVRow>>, filename: string) => void,
): void => {
  const f = acceptedFiles[0];
  const parsePromise = new Promise<ParseResult<CSVRow>>((resolve, reject) => {
    Papa.parse<CSVRow, File>(f, {
      header: true,
      skipEmptyLines: true,
      complete(results) {
        resolve(results);
      },
      error(error: Error) {
        reject(error);
      },
    });
  });
  parseComplete(parsePromise, f.name);
};

const BulkUpdateCSVDropZone = (props: Props): React.ReactElement => {
  const { buttonLabel = "Upload update file", parseComplete } = props;

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDrop: (acceptedFiles): void => {
      processAcceptFiles(acceptedFiles, parseComplete);
    },
  });

  return (
    <Button {...getRootProps({ color: "brandLight" })}>
      <>
        <input {...getInputProps()} />
        {buttonLabel}
      </>
    </Button>
  );
};

export default BulkUpdateCSVDropZone;
